<template>
  <main>
    <sub-tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-green">
                        轄下異動後實質接觸
                    </h4>
                    <form class="form">
                        <div class="form-group row">
                            <label class="col-1 text-right">受撥月份</label>
                            <div class="col-11">
                                <select class="form-control form-control-inline ml-0" v-model="form.startYear">
                                    <option value="108">108 年</option>
                                </select>
                                <span class="text">/</span>
                                <select class="form-control form-control-inline" v-model="form.startMonth">
                                    <option value="1">1 月</option>
                                </select>
                                <span class="text">～</span>
                                <select class="form-control form-control-inline" v-model="form.endYear">
                                    <option value="108">108 年</option>
                                </select>
                                <span class="text">/</span>
                                <select class="form-control form-control-inline" v-model="form.endMonth">
                                    <option value="2">2 月</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-1 text-right">服務人員</label>
                            <div class="col-3">
                                <select name="" id="" class="form-control">
                                    <option value="">
                                        全部
                                    </option>
                                </select>
                            </div>
                            <div class="col-11 offset-1">
                                <div class="float-right pt-3">
                                    <a href="#" class="link text-underline">
                                        保戶拜訪SOP(含未訪件說明)
                                    </a>
                                </div>
                                <a @click="searchData()" class="btn btn-primary ml-0">查詢</a>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-12">
                    <table class="table datatable insurance-green">
                        <thead>
                            <tr>
                                <th class="text-center" colspan="10">實質接觸前</th>
                                <th class="text-center" colspan="2">實質接觸後</th>
                            </tr>
                            <tr>
                                <th>#</th>
                                <th class="sorting" :class="order.index==1 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(1)">客戶<br/>姓名</th>
                                <th class="sorting" :class="order.index==2 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(2)">客戶<br/>標記</th>
                                <th class="sorting" :class="order.index==3 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(3)">保單號碼</th>
                                <th class="sorting" :class="order.index==4 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(4)">原收費<br/>號碼</th>
                                <th class="sorting" :class="order.index==5 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(5)">收費<br/>代號</th>
                                <th class="sorting" :class="order.index==6 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(6)">下次<br/>應繳日</th>
                                <th class="sorting" :class="order.index==7 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(7)">契約<br/>效力</th>
                                <th class="sorting" :class="order.index==8 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(8)">保戶<br/>通聯</th>
                                <th class="sorting" :class="order.index==9 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(9)">實質接<br/>觸期限</th>
                                <th class="sorting" :class="order.index==10 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(10)">撥入<br/>原因</th>
                                <th class="sorting" :class="order.index==11 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : ''" @click="columnSorting(11)">已實質<br/>接觸</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>{{rid + 1}}</td>
                            <td>{{row.name}}</td>
                            <td>{{row.sign}}</td>
                            <td>{{row.insure_no}}</td>
                            <td>{{row.receive_no}}</td>
                            <td>{{row.receive_code}}</td>
                            <td>{{row.nextPayAt}}</td>
                            <td>
                                <span v-if="row.validity==1">正常</span>
                                <span v-if="row.validity==2">終身險<br/>滿期</span>
                                <span v-if="row.validity==3">繳清件</span>
                            </td>
                            <td>
                                <a @click="panelOpen('connectModalOpen')" class="link text-underline">查詢</a>
                            </td>
                            <td>
                                {{row.connectAt}}
                            </td>
                            <td>
                                {{row.connectReason}}
                            </td>
                            <td class="text-center">
                                <span v-if="row.isConnect">&#10004;</span>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentRowID && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="12">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="12">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   
                    <div v-if="tableRow && tableRow.length">
                        <ol>
                            <li>保單號碼開頭為0、1、含英文字母及部分9100開頭者，為原專寶專福的服務件，有任何疑問請洽總公司保護<br/>部保費企劃科，(02)27551399#1916</li>
                            <li>如有其他疑問，請洽總公司業務部企劃科，(02)27551399#2032、2039</li>
                        </ol>
                    </div>
                </div>

            </div>
        </div>
      </div>
    </div>

    <connect-data-modal
    :open="connectModalOpen"
    @close="panelClose('connectModalOpen')"/>
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import SubTabHeader from '@/desktop/components/submanager/TabHeader'
import ConnectDataModal from '@/desktop/components/submanager/ConnectData'

const dataTree = [
  {
    id: 1,
    name: '安潔莉',
    sign: 'VIP',
    insure_no: 5659011234,
    receive_no: 'E21999A',
    receive_code: 'E21999A',
    nextPayAt: '108/03/15',
    validity: 1,
    connect: '',
    connectAt: '108/03/15',
    connectReason: '低職級',
    isConnect: 1,
  },
  {
    id: 2,
    name: '歐巴馬',
    sign: '1年未接觸',
    insure_no: 5659011234,
    receive_no: 'E21999A',
    receive_code: 'E21999A',
    nextPayAt: '108/03/15',
    validity: 2,
    connect: '',
    connectAt: '108/03/15',
    connectReason: '低職級',
    isConnect: 0,
  },
  {
    id: 3,
    name: '陳其邁',
    sign: '2年未接觸',
    insure_no: 5659011234,
    receive_no: 'E21999A',
    receive_code: 'E21999A',
    nextPayAt: '108/03/15',
    validity: 3,
    connect: '',
    connectAt: '108/03/15',
    connectReason: '低職級',
    isConnect: 0,
  },
  {
    id: 4,
    name: '高絲駁',
    sign: '密戶',
    insure_no: 5659011234,
    receive_no: 'E21999A',
    receive_code: 'E21999A',
    nextPayAt: '108/03/15',
    validity: 1,
    connect: '',
    connectAt: '108/03/15',
    connectReason: '低職級',
    isConnect: 1,
  },
]

export default {
  name: 'TransferTab52',
  mixins: [commonMixin],
  components: {
    SubTabHeader, ConnectDataModal
  },
  computed: {
    tableRow () {
        if (this.currentRowID==0) return null
        this.dataTree = dataTree
        return this.dataTree.filter(row => row.parent == this.currentRowID)
    },
    breadcrumbs () {
      if(this.currentRowID==0)
        return []
      else
        return (this.getParentPath(this.currentRowID)).reverse()
    }
  },
  data () {
    return {
        connectModalOpen: false,
      order: {
          index: 1,
          asc: true
      },
      form: {
        startYear: '',
        startMonth: '',
        endYear: '',
        endMonth: ''
      },
      order: {
          index: 1,
          asc: true
      },
      dataTree: [],
      currentRowID: 0,
    }
  },
  watch: {
      'searchType': 'changeData'
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    getParentPath (parent) {
      let path = []
      this.dataTree.forEach(row => {
        if (row.id == parent) {
          path.push({
            id: row.id,
            name: row.type
          })
          if (row.parent) {
            path = path.concat(this.getParentPath(row.parent))
          }
        }
      })
      // console.log(parent, path)
      return path
    },
    searchData () {
      this.currentRowID = null;
      // this.getPath(this.tableRow)
    },
    countTotal (key) {
      let list =  this[''] 
      if (!this.tableRow) return
      
      let num = 0
      this.tableRow.forEach(row => {
        num += row[key]
      })

      if(key.toLowerCase().indexOf('rate') > -1) {
        num =  num/this.tableRow.length
      }
      return num
    },
    columnSorting(i) {
        if (this.order.index == i) {
            this.order.asc = !this.order.asc
        } else {
            this.order.asc = true
        }
        this.order.index = i
    },
    changeData () {
        // Call API
      // this.breadcrumbs = []
      this.currentRowID = 0;
    }
  },
  beforeMount () {
  },
  mounted () {
  }
}
</script>
